import { Row, Select } from "antd";
import { useState, useEffect, DownOutlined } from "react";

const { Option } = Select;

export const SelectCustomCampeonatos = ({
  idCampo,
  nombreCampo,
  arrayOpciones,
  textoOpciones,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(elValue || null);
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setSelectedValue(elValue || null);
  }, [elValue]);

  const handleSelectChange = (selectedValue) => {
    setSelectedValue(selectedValue);
    onChange({ target: { value: String(selectedValue), id: idCampo } });
  };

  return (
    <Row className="row-selectCampeonato" justify={"center"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">{nombreCampo} {esRequired}</p>
      </label>
      <Select
      className="select-custom"
      showSearch
      autoComplete="none"
      key={idCampo + "*" + selectedValue}
      id={idCampo}
      onChange={handleSelectChange}
      placeholder={elPlaceholder}
      style={{ width: "50%" }}
      required={required}
      value={selectedValue !== null ? String(selectedValue) : undefined}
      filterOption={(input, option) =>
        (String(option.children) || "").toLowerCase().includes(input.toLowerCase())
      }
      status={tipoError}

    >
      {arrayOpciones.map((option) => (
        <Option key={option.id} value={String(option.id)}>
          {typeof textoOpciones === "function"
            ? textoOpciones(option)
            : option[textoOpciones]}
        </Option>
      ))}
    </Select>
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
